<template>
  <el-dialog
    :title="
      configType === 'equipment'
        ? $t('user.MachineUser.9398851-0')
        : advertGroup.id
        ? $t('adverts.AddAdvertGroup.519275-0')
        : $t('adverts.AddAdvertGroup.519275-1')
    "
    :visible.sync="dialogVisible"
    width="90%"
    top="5vh"
    @closed="closeDialog"
    @open="openDialog"
    :close-on-click-modal="false"
    custom-class="advert-group-dialog"
  >
    <div v-loading="loading">
      <el-card shadow="never" class="group-card" v-if="configType !== 'equipment'">
        <div slot="header">
          <span>{{ $t("adverts.AddAdvertGroup.519275-2") }}</span>
        </div>
        <el-form
          :model="advertGroup"
          :rules="rules"
          ref="advertGroupForm"
          :label-width="$i18n.locale == 'zh_CN' ? '100px' : '120px'"
        >
          <el-form-item :label="$t('adverts.AddAdvertGroup.519275-3')" prop="name">
            <el-input
              v-model="advertGroup.name"
              :placeholder="$t('adverts.AddAdvertGroup.519275-4')"
              clearable
              maxlength="50"
              show-word-limit
              style="width: 400px"
            />
          </el-form-item>
        </el-form>
      </el-card>

      <el-card shadow="never" class="config-card">
        <div slot="header">
          <span>{{ $t("adverts.AddAdvertGroup.519275-5") }}</span>
        </div>
        <div class="config-content">
          <div class="left-section">
            <advert-slot-tabs
              :screen-saver-adverts="screenSaverAdverts"
              :top-banner-adverts="topBannerAdverts"
              :external-screen-adverts="externalScreenAdverts"
              :active-tab.sync="activeTab"
              :editable="true"
              @remove="removeFromSlot"
              @clear="clearSlot"
            />
          </div>

          <advert-list-panel
            :advert-list="advertList"
            :page="page"
            :loading="advertListLoading"
            :search-keyword.sync="searchKeyword"
            :filter-type.sync="filterType"
            :current-tab-adverts="getCurrentTabAdverts()"
            :all-adverts="getAllAdvertsObject()"
            @add="addToCurrentSlot"
            @remove-selected="removeFromCurrentSlot"
            @add-advert="handleAddAdvert"
            @search="handleSearch"
            @reset="handleReset"
            @size-change="handleSizeChange"
            @page-change="handlePageChange"
            class="right-section"
          />
        </div>
      </el-card>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel('')" size="medium">{{ $t("adverts.AddAdvertGroup.519275-6") }}</el-button>
      <el-button type="primary" :loading="loadingForm" @click="submitForm" size="medium">
        {{
          configType === "equipment"
            ? $t("common.definite")
            : advertGroup.id
            ? $t("adverts.AddAdvertGroup.519275-7")
            : $t("adverts.AddAdvertGroup.519275-8")
        }}
      </el-button>
      <el-button
        v-if="configType !== 'equipment' && !advertGroup.id"
        type="success"
        :loading="loadingForm"
        @click="submitFormAndBindMachine"
        size="medium"
        v-hasPerm="['advert:group:config']"
      >
        {{ $t("adverts.AddAdvertGroup.519275-9") }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  import AdvertSlotTabs from "@/components/advert-config/AdvertSlotTabs.vue";
  import AdvertListPanel from "@/components/advert-config/AdvertListPanel.vue";
  import advertConfigMixin from "@/components/advert-config/advertConfigMixin.js";

  export default {
    name: "AddAdvertGroup",
    components: {
      AdvertSlotTabs,
      AdvertListPanel
    },
    mixins: [advertConfigMixin],
    props: {
      advertGroup: {
        type: Object,
        required: true
      },
      dialogAdvertGroup: {
        type: Boolean,
        default: false
      },
      apiNamespace: {
        type: String,
        default: "AdvertGroup"
      },
      configType: {
        type: String,
        default: "group",
        validator: value => ["group", "equipment"].includes(value)
      },
      equipmentId: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        dialogVisible: false,
        loading: false,
        loadingForm: false,
        rules: {
          name: [
            {
              required: true,
              message: this.$t("adverts.AddAdvertGroup.519275-4"),
              trigger: "blur"
            },
            {
              min: 1,
              max: 50,
              message: this.$t("adverts.AddAdvertGroup.519275-10"),
              trigger: "blur"
            }
          ]
        }
      };
    },
    watch: {
      dialogAdvertGroup(val) {
        this.dialogVisible = val;
        if (val) {
          this.init();
        }
      }
    },
    methods: {
      async init() {
        this.activeTab = "screenSaver";
        this.searchKeyword = "";
        this.filterType = "";
        await this.loadAdvertList();

        if (this.configType === "equipment" && this.equipmentId) {
          await this.loadEquipmentAdverts();
        } else if (this.advertGroup.id) {
          await this.loadGroupAdverts();
        }
      },

      openDialog() {},

      async loadEquipmentAdverts() {
        if (!this.equipmentId) return;

        this.loading = true;
        try {
          const res = await this.$api.request(this.$url.UserEquipmentAd.listByEquipmentId, this.$method.get, {
            equipmentId: this.equipmentId
          });

          if (res.code === 0 && res.data && Array.isArray(res.data)) {
            this.screenSaverAdverts = [];
            this.topBannerAdverts = [];
            this.externalScreenAdverts = [];

            res.data.forEach(advert => {
              if (advert.display === 1 || advert.display === "1") {
                this.screenSaverAdverts.push(advert);
              } else if (advert.display === 2 || advert.display === "2") {
                this.topBannerAdverts.push(advert);
              } else if (advert.display === 3 || advert.display === "3") {
                this.externalScreenAdverts.push(advert);
              }
            });

            this.screenSaverAdverts.sort((a, b) => (a.sort || 0) - (b.sort || 0));
            this.topBannerAdverts.sort((a, b) => (a.sort || 0) - (b.sort || 0));
            this.externalScreenAdverts.sort((a, b) => (a.sort || 0) - (b.sort || 0));
          }
        } catch (error) {
          console.error(this.$t("adverts.AddAdvertGroup.519275-11"), error);
        } finally {
          this.loading = false;
        }
      },

      async loadGroupAdverts() {
        if (!this.advertGroup.id) return;

        this.loading = true;
        try {
          const apiUrl = this.$url[this.apiNamespace]?.listByAdTeamId;
          const res = await this.$api.request(apiUrl, this.$method.get, {
            id: this.advertGroup.id
          });

          if (res.code === 0 && res.data && Array.isArray(res.data)) {
            this.screenSaverAdverts = [];
            this.topBannerAdverts = [];
            this.externalScreenAdverts = [];

            res.data.forEach(advert => {
              if (advert.display === 1 || advert.display === "1") {
                this.screenSaverAdverts.push(advert);
              } else if (advert.display === 2 || advert.display === "2") {
                this.topBannerAdverts.push(advert);
              } else if (advert.display === 3 || advert.display === "3") {
                this.externalScreenAdverts.push(advert);
              }
            });

            this.screenSaverAdverts.sort((a, b) => (a.sort || 0) - (b.sort || 0));
            this.topBannerAdverts.sort((a, b) => (a.sort || 0) - (b.sort || 0));
            this.externalScreenAdverts.sort((a, b) => (a.sort || 0) - (b.sort || 0));
          }
        } catch (error) {
          console.error(this.$t("adverts.AddAdvertGroup.519275-11"), error);
        } finally {
          this.loading = false;
        }
      },

      cancel(status) {
        this.$emit("cancel", false, status);
      },

      submitForm() {
        if (this.configType === "equipment") {
          this.submitEquipmentAdConfig();
          return;
        }

        this.$refs.advertGroupForm.validate(async valid => {
          if (valid) {
            this.loadingForm = true;
            try {
              const adBinds = [];

              this.screenSaverAdverts.forEach(advert => {
                adBinds.push({
                  adId: advert.id,
                  display: 1
                });
              });

              this.topBannerAdverts.forEach(advert => {
                adBinds.push({
                  adId: advert.id,
                  display: 2
                });
              });

              this.externalScreenAdverts.forEach(advert => {
                adBinds.push({
                  adId: advert.id,
                  display: 3
                });
              });

              const data = {
                name: this.advertGroup.name,
                adBinds: adBinds
              };

              if (this.advertGroup.id) {
                data.id = this.advertGroup.id;
              }

              const apiUrlObj = this.$url[this.apiNamespace];
              const url = this.advertGroup.id ? apiUrlObj?.update : apiUrlObj?.insert;
              const method = this.advertGroup.id ? this.$method.put : this.$method.post;

              const res = await this.$api.request(url, method, data);

              if (res.code === 0) {
                this.$message.success(
                  this.advertGroup.id
                    ? this.$t("adverts.AddAdvertGroup.519275-12")
                    : this.$t("adverts.AddAdvertGroup.519275-13")
                );
                this.cancel(this.advertGroup.id ? "update" : "save");
              } else {
                this.$message.error(res.msg || this.$t("adverts.AddAdvertGroup.519275-14"));
              }
            } catch (error) {
              console.error(this.$t("adverts.AddAdvertGroup.519275-15"), error);
              this.$message.error(error.msg || this.$t("adverts.AddAdvertGroup.519275-14"));
            } finally {
              this.loadingForm = false;
            }
          }
        });
      },

      submitEquipmentAdConfig() {
        this.loadingForm = true;
        try {
          const adBinds = [];

          this.screenSaverAdverts.forEach(advert => {
            adBinds.push({
              adId: advert.id,
              display: 1
            });
          });

          this.topBannerAdverts.forEach(advert => {
            adBinds.push({
              adId: advert.id,
              display: 2
            });
          });

          this.externalScreenAdverts.forEach(advert => {
            adBinds.push({
              adId: advert.id,
              display: 3
            });
          });

          const data = {
            id: this.equipmentId,
            adBinds: adBinds
          };

          this.$api
            .request(this.$url.UserEquipmentAd.config, this.$method.post, data)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t("common.operateSuccess"));
                this.cancel("update");
              } else {
                this.$message.error(res.msg || this.$t("common.operateFailed"));
              }
            })
            .catch(error => {
              this.$message.error(error.msg || this.$t("common.operateFailed"));
            })
            .finally(() => {
              this.loadingForm = false;
            });
        } catch (error) {
          this.loadingForm = false;
          this.$message.error(error.msg || this.$t("common.operateFailed"));
        }
      },

      submitFormAndBindMachine() {
        this.$refs.advertGroupForm.validate(async valid => {
          if (valid) {
            this.loadingForm = true;
            try {
              const adBinds = [];

              this.screenSaverAdverts.forEach(advert => {
                adBinds.push({
                  adId: advert.id,
                  display: 1
                });
              });

              this.topBannerAdverts.forEach(advert => {
                adBinds.push({
                  adId: advert.id,
                  display: 2
                });
              });

              this.externalScreenAdverts.forEach(advert => {
                adBinds.push({
                  adId: advert.id,
                  display: 3
                });
              });

              const data = {
                name: this.advertGroup.name,
                adBinds: adBinds
              };

              const apiUrl = this.$url[this.apiNamespace]?.insert;
              const res = await this.$api.request(apiUrl, this.$method.post, data);

              if (res.code === 0) {
                this.$message.success(this.$t("adverts.AddAdvertGroup.519275-13"));
                const newGroupId = res.data && res.data.id ? res.data.id : "";

                if (!newGroupId) {
                  this.$message.error(this.$t("adverts.AddAdvertGroup.519275-16"));
                  return;
                }

                this.cancel("save");
                this.$emit("open-machine-group-config", newGroupId);
              } else {
                this.$message.error(res.msg || this.$t("adverts.AddAdvertGroup.519275-17"));
              }
            } catch (error) {
              console.error(this.$t("adverts.AddAdvertGroup.519275-18"), error);
              this.$message.error(error.msg || this.$t("adverts.AddAdvertGroup.519275-17"));
            } finally {
              this.loadingForm = false;
            }
          }
        });
      },

      handleAddAdvert() {
        this.$emit("add-advert");
      },

      closeDialog() {
        if (this.$refs.advertGroupForm) {
          this.$refs.advertGroupForm.clearValidate();
        }

        this.screenSaverAdverts = [];
        this.topBannerAdverts = [];
        this.externalScreenAdverts = [];

        this.cancel("");
      }
    }
  };
</script>

<style lang="scss" scoped>
  .group-card {
    margin-bottom: 20px;

    ::v-deep .el-card__header {
      background: #f5f7fa;
      font-weight: 500;
    }
  }

  .config-card {
    ::v-deep .el-card__header {
      background: #f5f7fa;
      font-weight: 500;
    }

    ::v-deep .el-card__body {
      padding: 20px;
    }
  }

  .config-content {
    display: flex;
    gap: 20px;
    height: 600px;
  }

  .left-section {
    flex: 1;
    overflow: hidden;
  }

  .right-section {
    flex: 1;
    overflow: hidden;
  }

  ::v-deep .advert-group-dialog {
    .el-dialog__header {
      background: #fafafa;
      border-bottom: 1px solid #ebeef5;
    }

    .el-dialog__body {
      padding: 20px;
      background: #f5f7fa;
    }

    .el-dialog__footer {
      border-top: 1px solid #ebeef5;
    }
  }
</style>
